import { useCallback, useState } from "react";
/* import { useRouter } from "next/router"; */

export interface UseServicesListPaginationProps {
  limit?: number;
}

export interface UseServicesListPaginationReturn {
  page: number;
  limit: number;
  handlePageChange: (newPage: number) => void;
  resetToFirstPage: () => void;
}

export const useServicesListPagination = ({
  limit = 4,
}: UseServicesListPaginationProps = {}): UseServicesListPaginationReturn => {
  /* const router = useRouter(); */
  /* const isUpdatingRef = useRef(false); */
  
  // Simple local state for pagination (no URL sync)
  const [page, setPage] = useState(1);
  
  /*
  Original URL-based implementation commented out:
  
  // Get page from URL query parameter, default to 1
  const currentPage = useMemo(() => {
    const pageParam = router.query.page;
    if (typeof pageParam === "string") {
      const parsed = parseInt(pageParam, 10);
      return parsed > 0 ? parsed : 1;
    }
    return 1;
  }, [router.query.page]);

  const [page, setPage] = useState(currentPage);
  const pageRef = useRef(page);
  const currentPageRef = useRef(currentPage);
  
  // Update refs when values change
  useEffect(() => {
    pageRef.current = page;
  }, [page]);
  
  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);
  
  // Sync page state with URL parameter only when not in the middle of an update
  useEffect(() => {
    if (!isUpdatingRef.current && currentPage !== pageRef.current) {
      setPage(currentPage);
    }
  }, [currentPage]);

  // Shared function to update page and URL
  const updatePageAndUrl = useCallback(async (newPage: number) => {
    // Set flag to prevent sync during update
    isUpdatingRef.current = true;
    
    // Update local state immediately for UI responsiveness
    setPage(newPage);
    
    // Update URL with new page parameter
    const newQuery = { ...router.query };
    if (newPage === 1) {
      delete newQuery.page; // Remove page parameter for page 1 to keep URL clean
    } else {
      newQuery.page = newPage.toString();
    }
    
    await router.push({
      pathname: router.pathname,
      query: newQuery,
    }, undefined, { shallow: true });
    
    // Reset flag after update is complete
    isUpdatingRef.current = false;
  }, [router]);
  */

  const handlePageChange = useCallback((newPage: number) => {
    // Simple state update without URL sync
    setPage(newPage);
  }, []);

  const resetToFirstPage = useCallback(() => {
    // Simple state update without URL sync
    setPage(1);
  }, []);

  return {
    page,
    limit,
    handlePageChange,
    resetToFirstPage,
  };
}; 